import React from 'react';
import './style.scss';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CustomModal = ({ children, visible, onClose, background = '#4C4C4C', color = undefined }) => (
  <Modal
    size="xl"
    className="custom-modal trigger-sticky"
    show={visible}
    onHide={onClose}
    dialogClassName="custom-modal-dialog"
    contentClassName="custom-modal-content"
    style={{ background, color }}
  >
    {children}
  </Modal>
);

CustomModal.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  background: PropTypes.string,
  color: PropTypes.string,
};

export default CustomModal;
